function ASCIIAnimation (animArray, speed, DOMtarget) {
  let currentFrame = 0
  for (var i = 0; i < animArray.length; i++) {
    animArray[i] = animArray[i].replace(/ /g, "&nbsp;")
    animArray[i] = "<pre>" + animArray[i] + "</pre>"
  }
  DOMtarget.innerHTML = animArray[0]
  currentFrame++

  setInterval(function () {
    DOMtarget.innerHTML = animArray[currentFrame]
    currentFrame++
    if (currentFrame >= animArray.length) currentFrame = 0
  }, speed)
}

document.addEventListener("alpine:init", () => {
  Alpine.data("ThemeModule_CartItems", (context, initialCart) => {
    /** The max amount of each free gift we allow per cart (order) */
    const freeGiftQuantityLimit = 1

    return {
      context: context,
      itemsRoot: null,
      locked: null,
      items_section: "",
      sections: "",
      cart: initialCart,
      sets: new Map(),
      setsState: {
        loading: false,
        error: null,
        success: false
      },
      logger (...messages) {
        console.debug('[cart-items.js]', ...messages)
      },
      init () {
        this.logger('Setting initial state to', initialCart)

        if (context === "drawer") {
          this.items_section = "drawer-cart-items"
          this.sections =
            "drawer-cart-items,drawer-cart-footer,cart-item-count,cart-live-region"
        } else {
          this.items_section = "cart-items"
          this.sections =
            "cart-items,cart-items,cart-footer,cart-item-count,cart-live-region"
        }

        this.itemsRoot = this.$root

        this.setupEmptyAscii()

        if (window.__cartSetsData__) {
          this.sets = new Map(window.__cartSetsData__)
        }

        // Setup free gift checks
        this.handleFreeGiftChecks(initialCart)
        this.$watch('cart', cart => this.handleFreeGiftChecks(cart))

        window.addEventListener("switch:cart:afteradditem", (e) => {
          this.logger('Handling switch:cart:afteradditem event', e.detail.response)

          // This is from an `/add.js` response, so it returns the item/s, NOT the cart object.
          if (typeof e.detail.response === 'object') {
            const items = Array.isArray(e.detail.response.items) ? e.detail.response.items : [e.detail.response]
            // If this causes issues, we can re-fetch the cart instead?
            this.cart.items.unshift(...items)
          }

          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              "[data-cart-items]",
              e.detail.response.sections[this.items_section]
            ).outerHTML
          )
          this.$nextTick(() => {
            document.body.dispatchEvent(
              new CustomEvent("switch:load:images", { bubbles: true })
            )
            this.setupEmptyAscii()
          })
        })

        window.addEventListener("switch:modalcart:cartqtychange", (e) => {
          this.logger('Handling switch:modalcart:cartqtychange event', e.detail.response)

          if (typeof e.detail.response === 'object') this.cart = e.detail.response

          //if (!this.itemsRoot.contains(e.detail.originalTarget)) return

          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              "[data-cart-items]",
              e.detail.response.sections[this.items_section]
            ).outerHTML
          )

          this.$nextTick(() => {
            document.body.dispatchEvent(
              new CustomEvent("switch:load:images", { bubbles: true })
            )
            this.itemsRoot.querySelectorAll("input").forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute("value")
            })
            this.setupEmptyAscii()
          })

          const liveRegionText = parseDOMFromString(
            e.detail.response.sections["cart-live-region"]
          ).firstElementChild.textContent

          const cartStatus = document.getElementById("cart-live-region-text")

          cartStatus.textContent = liveRegionText

          cartStatus.setAttribute("aria-hidden", false)

          setTimeout(() => {
            cartStatus.setAttribute("aria-hidden", true)
          }, 1000)

          if (e.detail.originalTarget) {
            this.$nextTick(() => {
              if (!this.itemsRoot.contains(e.detail.originalTarget)) {
                let focusRoot

                if (this.itemsRoot.closest('[role="dialog"]')) {
                  focusRoot =
                    this.itemsRoot.closest('[role="dialog"]').parentNode
                } else {
                  focusRoot = this.itemsRoot
                }

                this.$focus.within(focusRoot).first()
              }

              this.setupEmptyAscii()
            })
          }
        })
      },
      /** Returns an array of all free gift product ID's */
      get freeGiftProductIds () {
        return Array.from(this.sets.values()).flatMap(set => set.gifts.map(item => item.id))
      },
      /** A fn to check if a line item is a free gift. */
      isFreeGiftItem (productId) {
        if (!productId) return false
        return this.freeGiftProductIds.includes(productId)
      },
      itemQuantityChange (key, value) {
        if (this.locked) return

        const lineItemEl = this.$el.closest("li[data-cart-item-key]")
        const id = key ? key : lineItemEl.getAttribute("data-cart-item-key"),
          quantity = parseInt(!isNaN(value) ? value : this.$el.value, 10)

        const config = fetchConfigDefaults()

        let sections = this.sections

        config.headers.Accept = "application/javascript"

        config.body = JSON.stringify({
          id,
          quantity,
          sections,
          sections_url: window.location.pathname,
        })

        const lastValue = parseInt(this.$el.dataset.lastValue, 10)

        if (quantity !== lastValue) {
          lineItemEl.classList.add("opacity-50", "cursor-progress")

          const currentCount = Alpine.raw(Alpine.store("cart_count").count)

          this.locked = lineItemEl

          fetch(theme.routes.cart_change_url, config)
            .then((res) => res.json())
            .then((data) => {
              if (data.status === 422) {
                const errorEl = lineItemEl.querySelector(
                  "[data-cart-quantity-error]"
                )

                errorEl.textContent = data.message

                errorEl.classList.remove("hidden")

                lineItemEl.classList.remove("opacity-50", "cursor-progress")

                this.$el.value = lastValue
                this.$el.dispatchEvent(new Event("input"))
              } else {
                document.body.dispatchEvent(
                  new CustomEvent("switch:modalcart:cartqtychange", {
                    bubbles: true,
                    detail: { response: data, originalTarget: lineItemEl },
                  })
                )
              }
            })
            .catch(() => {
              document.getElementById("cart-errors").textContent =
                theme.strings.cartError
            })
            .finally(() => {
              this.locked = null
            })
        }
      },
      removeItem (key) {
        this.itemQuantityChange(key, 0)
      },
      _adjustQty (el, operation) {
        const inputEl = el
          .closest("li[key]")
          .querySelector('input[type="number"]')

        const lastValue = parseInt(inputEl.dataset.lastValue, 10)

        let newValue

        if (operation == "increment") {
          newValue = lastValue + 1
        }

        if (operation == "decrement") {
          if (lastValue > 1) {
            newValue = lastValue - 1
          } else {
            newValue = 1
          }
        }

        if (operation == "remove") {
          newValue = 0
        }

        inputEl.value = newValue

        // this.$nextTick(() => {
        inputEl.dispatchEvent(new Event("change", { bubbles: true }))
        // });
      },
      increment () {
        this._adjustQty(this.$el, "increment")
      },
      decrement () {
        this._adjustQty(this.$el, "decrement")
      },
      remove () {
        this._adjustQty(this.$el, "remove")
      },
      openNewsletter (e) {
        e.preventDefault()
        $("#shopify-section-popup-newsletter").fadeIn()
      },
      /** This checks the current cart to make sure we only have the max limit of gift items in there */
      async handleFreeGiftChecks (cart = this.cart) {
        this.logger('Running free gift checks', cart)

        const freeGiftProductIds = this.freeGiftProductIds
        const freeGiftItemsInCart = cart.items.filter(item => item.product_id && freeGiftProductIds.includes(item.product_id))
        if (!freeGiftItemsInCart.length) return

        // Remove if we have no set items in the cart (this assumes we only have one set atm?)
        const setItemsIds = Array.from(this.sets.values()).flatMap(set => set && set.main ? [set.main.id] : [])
        const hasSetItemsInCart = cart.items.some(item => item.product_id && setItemsIds.includes(item.product_id))

        // An array of updates, in the form of [item.key, quantity] - we'll add this to object in a bit
        const updates = []

        if (!hasSetItemsInCart) {
          const cartItemsToUpdate = freeGiftItemsInCart.map(item => [item.key, 0])
          updates.push(...cartItemsToUpdate)

          this.logger('No set items in the cart - removing all free gifts', { cartItemsToUpdate })
        } else {
          // Cart items we need to update to change to the max limit
          const cartItemsToUpdate = freeGiftItemsInCart.flatMap(item => {
            if (item.quantity <= freeGiftQuantityLimit) return []

            return [[item.key, freeGiftQuantityLimit]]
          })

          updates.push(...cartItemsToUpdate)
          this.logger('We need to update free gift item quantities:', { cartItemsToUpdate })
        }

        if (!updates.length) return

        this.logger('We need to run some updates:', { updates })

        try {
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              updates: Object.fromEntries(updates),
              sections: this.sections,
              sections_url: window.location.pathname,
            })
          })

          if (!response.ok) {
            const text = await response.text()
            console.error(`Failed to remove items from cart`, text, response)
            throw new Error(text)
          }

          this.logger('Finished free gift checks, refreshing cart')

          const data = await response.json()
          document.body.dispatchEvent(
            new CustomEvent("switch:modalcart:cartqtychange", {
              bubbles: true,
              detail: { response: data },
            })
          )
        } catch (error) {
          console.error('[cart-items.js]', error.message, error)
        }
      },
      /**
       * Handles adding 'sets' to cart - when called, it will remove any
       * set items from the cart, and replace them with the 'main' set product.
       *
       * This is basically simple bundle functionality.
       */
      async handleSet (handle) {
        try {
          this.logger('Handling set', { handle })

          const set = this.sets.get(handle)
          if (!set) {
            console.error(`No set found with handle ${ handle }`)
            return
          }

          this.setsState = { loading: true, success: false, error: null }

          // Fetch current cart (don't know why we don't have this in state)
          const response = await fetch('/cart.js')
          if (!response.ok) {
            const text = await response.text()
            console.error(`Failed to fetch cart`, text, response)
            throw new Error(`Failed to fetch cart - please try again`)
          }

          const cart = await response.json()

          // Find existing contents in cart - atm we only have default variants, so we can just use product ID's.
          const setContentsIds = set.contents.map(item => item.id)
          const contentsInCart = cart.items.filter(item => setContentsIds.includes(item.product_id))

          /**
           * Handle quantity of sets - i.e. if we have 2 x oil, then we should add set x 2,
           * and if we have 3 x oil, and 1 x pad, we should add 2 x sets as well.
           *
           * NOTE: At the moment, we just find the max qty
           */
          const contentsMaxQuantity = contentsInCart.reduce((quantity, item) => Math.max(quantity, item.quantity), 0)

          // Remove any contents from the cart
          const updates = Object.fromEntries(contentsInCart.map(item => [item.key, 0]))
          const remResponse = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              updates,
              sections: this.sections,
              sections_url: window.location.pathname,
            })
          })

          if (!remResponse.ok) {
            const text = await remResponse.text()
            console.error(`Failed to remove items from cart`, text, response)
            throw new Error(text)
          }

          // Add the main product + any free gifts


          // May need to handle different variants if free gift has more than the default
          const giftsInput = set.gifts.flatMap(item => {
            // We only allow one per order, so check if we have already added
            const alreadyInCart = cart.items.some(item => item.product_id === item.id)
            if (alreadyInCart) return []

            const [defaultVariant] = item.variants
            return defaultVariant ? [{ id: defaultVariant.id, quantity: freeGiftQuantityLimit }] : []
          })

          // Use the default variant - may need to handle different ones in future
          const [mainInput] = set.main.variants.map(variant => ({ id: variant.id, quantity: contentsMaxQuantity }))

          const items = [mainInput, ...giftsInput]
          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items,
              sections: this.sections,
              sections_url: window.location.pathname,
            })
          })

          if (!addResponse.ok) {
            const text = await addResponse.text()
            console.error(`Failed to add main item to cart`, text, response)
            throw new Error(text)
          }

          const addedItem = await addResponse.json()

          // const cartResponse = await fetch('/cart.js')
          // const currentCart = await cartResponse.json()

          // Reload to update cart
          this.setsState = { loading: false, success: true, error: null }

          document.body.dispatchEvent(
            new CustomEvent("switch:cart:afteradditem", {
              bubbles: true,
              detail: { response: addedItem },
            })
          )
        } catch (error) {
          console.error(error)
          this.setsState = { loading: false, success: false, error: 'Failed to add set to cart - please try again' }
          throw error
        }
      },
      setupEmptyAscii () {
        if (!this.$refs.cartEmpty) return

        const div = document.createElement("div")
        this.$refs.cartEmpty.replaceWith(div)

        div.style.fontFamily = "monospace"
        const animArray3 = [
          ".(^-^)'",
          "-(^-^)-",
          "'(^-^).",
          "-(^o^)-",
          ".(^-^)'",
          "-(^-^)-",
          "'(^-^).",
          "-(^-^)-",
        ]

        const anim3 = new ASCIIAnimation(animArray3, 125, div)
      },
    }
  })
})
